// components/Navigation.js
import React from 'react';
import { Link } from 'react-router-dom';


function Navigation({ currentStep, totalSteps, nextStep, prevStep }) {
  return (
    <div className="d-flex justify-content-between mt-4">
      {currentStep > 1 && (
        <button className="btn btn-outline-secondary" onClick={prevStep}>Previous</button>
      )}
      {currentStep < totalSteps ? (
        <button className="btn btn-kmint-blue" onClick={nextStep}>Next</button>
      ) : (
        <button className="btn btn-success">
            <Link to="/dashboard/partner" className="nav-link">
                Complete Onboarding
            </Link>
        </button>
      )}
    </div>
  );
}

export default Navigation;